/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseRedisEntity } from '@coin/shared/core/util-models';
import { COINSharedApplicationProtosResponsesStatusResponse } from '@coin/shared/core/util-models';
import { ConclusiveTransactionStatusOfTemplateSimulationMetadata } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryAttributeAssignmentsAttributeAssignmentsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseVersionsApproveClauseVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseVersionsClauseVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseVersionsCreateClauseVersionDraftModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseVersionsRejectClauseVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClauseVersionsUpdateClauseVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesAddNewClauseLanguageModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesClauseDetailsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesClauseFieldValueWithCountsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesCreateClauseModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesDuplicateClauseModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesExportClauseActivitiesModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesExportClauseTemplateAssociationsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesExportClausesModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryClausesRetireClauseModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryContractActionChangeStatusForAssignmentsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryContractActionContractActionDetailsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryContractAssignmentChangeSignersForAssignmentModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryContractAssignmentCheckPermissionsForDownloadModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryContractAssignmentContractAssignmentLightModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryContractAssignmentExportContractAssignmentsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryDocumentGenerationDocumentGenerationFieldValueWithCountsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryDocumentGenerationDocumentGenerationValidationRequestModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryDocumentGenerationGenerateNewDocumentsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryDocumentGenerationMatchedTemplateModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryDocumentGenerationPublishDocumentsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryEmployeesQuerySimulatedEmployeesModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateSimulationsSimulateTemplateContentModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionSettingsCreateTemplateVersionAttachmentModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionSettingsTemplateVersionAttachmentModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionsApproveTemplateVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionsCreateTemplateDraftVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionsRejectTemplateVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionsTemplateVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionsUpdateTemplateVersionContentModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplateVersionsUpdateTemplateVersionModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesCreateTemplateExportModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesCreateTemplateModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesDuplicateTemplateModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesExportTemplateActivitiesParameter } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesRetireTemplateModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesTemplateDetailsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesTemplateFieldValueWithCountsModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTemplatesUpdateTemplateRuleSetModel } from '@coin/shared/core/util-models';
import { EmploymentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel } from '@coin/shared/core/util-models';
import { SharedEmploymentConditionLibrarySendToApproverModel } from '@coin/shared/core/util-models';
import { SharedEntitySearchScopeModel } from '@coin/shared/core/util-models';
import { SharedFieldValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryAttributesAttributeLightModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryClausesClauseDetailsLightModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryContractActionContractActionLightModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryContractAssignmentContractAssignmentLightModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryTemplatesTemplateDetailsLightModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmploymentConditionLibraryUsersUserModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { SiemensEnergyCOINEmploymentConditionLibraryApiDtosCommonTemplateSimulationFilledTemplateContentResponse } from '@coin/shared/core/util-models';
import { TransactionStatusOfDocumentGenerationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface EmploymentConditionLibraryCustomerServiceAbortClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceAbortTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceAddAttachmentTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateVersionSettingsCreateTemplateVersionAttachmentModel?: EmploymentConditionLibraryTemplateVersionSettingsCreateTemplateVersionAttachmentModel;
}

export interface EmploymentConditionLibraryCustomerServiceAddNewClauseLanguageClausesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClausesAddNewClauseLanguageModel?: EmploymentConditionLibraryClausesAddNewClauseLanguageModel;
}

export interface EmploymentConditionLibraryCustomerServiceApproveClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseVersionsApproveClauseVersionModel?: EmploymentConditionLibraryClauseVersionsApproveClauseVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceApproveTemplateVersionsRequestParams {
  templateId: string;
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateVersionsApproveTemplateVersionModel?: EmploymentConditionLibraryTemplateVersionsApproveTemplateVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceArchiveContractActionContractActionsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceChangeSignersForAssignmentContractAssignmentRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryContractAssignmentChangeSignersForAssignmentModel?: EmploymentConditionLibraryContractAssignmentChangeSignersForAssignmentModel;
}

export interface EmploymentConditionLibraryCustomerServiceChangeStatusForAssignmentsContractActionsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryContractActionChangeStatusForAssignmentsModel?: EmploymentConditionLibraryContractActionChangeStatusForAssignmentsModel;
}

export interface EmploymentConditionLibraryCustomerServiceCheckPermissionsContractAssignmentRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryContractAssignmentCheckPermissionsForDownloadModel?: EmploymentConditionLibraryContractAssignmentCheckPermissionsForDownloadModel;
}

export interface EmploymentConditionLibraryCustomerServiceCreateClausesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClausesCreateClauseModel?: EmploymentConditionLibraryClausesCreateClauseModel;
}

export interface EmploymentConditionLibraryCustomerServiceCreateDraftClauseVersionsRequestParams {
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseVersionsCreateClauseVersionDraftModel?: EmploymentConditionLibraryClauseVersionsCreateClauseVersionDraftModel;
}

export interface EmploymentConditionLibraryCustomerServiceCreateDraftTemplateVersionsRequestParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateVersionsCreateTemplateDraftVersionModel?: EmploymentConditionLibraryTemplateVersionsCreateTemplateDraftVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceCreateTemplatesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplatesCreateTemplateModel?: EmploymentConditionLibraryTemplatesCreateTemplateModel;
}

export interface EmploymentConditionLibraryCustomerServiceDeleteAttachmentTemplateVersionsRequestParams {
  versionId: string;
  id: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceDeleteClauseLanguagesClausesRequestParams {
  id: string;
  languageCodes: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceDeleteClauseVersionsRequestParams {
  versionId: string;
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceDeleteTemplateVersionsRequestParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceDropContractActionContractActionsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceDuplicateClauseClausesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClausesDuplicateClauseModel?: EmploymentConditionLibraryClausesDuplicateClauseModel;
}

export interface EmploymentConditionLibraryCustomerServiceDuplicateTemplatesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplatesDuplicateTemplateModel?: EmploymentConditionLibraryTemplatesDuplicateTemplateModel;
}

export interface EmploymentConditionLibraryCustomerServiceExportClausesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClausesExportClausesModel?: EmploymentConditionLibraryClausesExportClausesModel;
}

export interface EmploymentConditionLibraryCustomerServiceExportContractAssignmentRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryContractAssignmentExportContractAssignmentsModel?: EmploymentConditionLibraryContractAssignmentExportContractAssignmentsModel;
}

export interface EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamClauseActivityStreamRequestParams {
  employmentConditionLibraryClausesExportClauseActivitiesModel?: EmploymentConditionLibraryClausesExportClauseActivitiesModel;
}

export interface EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamTemplateActivityStreamRequestParams {
  employmentConditionLibraryTemplatesExportTemplateActivitiesParameter?: EmploymentConditionLibraryTemplatesExportTemplateActivitiesParameter;
}

export interface EmploymentConditionLibraryCustomerServiceExportTemplateAssociationsClausesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClausesExportClauseTemplateAssociationsModel?: EmploymentConditionLibraryClausesExportClauseTemplateAssociationsModel;
}

export interface EmploymentConditionLibraryCustomerServiceExportTemplatesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplatesCreateTemplateExportModel?: EmploymentConditionLibraryTemplatesCreateTemplateExportModel;
}

export interface EmploymentConditionLibraryCustomerServiceGenerateContractActionContentDocumentGenerationRequestParams {
  actionId: string;
  employeeId: string;
}

export interface EmploymentConditionLibraryCustomerServiceGenerateDocumentGenerationRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryDocumentGenerationGenerateNewDocumentsModel?: EmploymentConditionLibraryDocumentGenerationGenerateNewDocumentsModel;
}

export interface EmploymentConditionLibraryCustomerServiceGetActivityStreamForVersionClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  page?: number;
  size?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetAttributesTemplateVersionSimulationRequestParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetCachedContentDocumentGenerationRequestParams {
  actionId: string;
  employeeId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetClauseDetailsClausesRequestParams {
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetClauseVersionClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetContractActionsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetCountryAndAreCountsContractActionsRequestParams {
  countries?: Array<string>;
  legalEntities?: Array<string>;
  contractActionStatus?: Array<'Active' | 'Archived'>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetLatestClauseVersionsRequestParams {
  clauseId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetLatestTemplateVersionsRequestParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetScopeAttributesRequestParams {
  name?: string;
  country?: string;
  legalEntity?: string;
  isGlobal?: boolean;
  searchQuery?: string;
  discriminator?: Array<string>;
  isAttributeUpload?: boolean;
  hasValuesAssigned?: boolean;
  includeValues?: boolean;
  variableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  templateVersionId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
}

export interface EmploymentConditionLibraryCustomerServiceGetSimulatedContentTemplateVersionSimulationRequestParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetTemplatesRequestParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceGetValuesByIdAttributesRequestParams {
  id: string;
  pageablePage?: number;
  pageableSize?: number;
  name?: string;
  country?: string;
  legalEntity?: string;
  isGlobal?: boolean;
  searchQuery?: string;
  discriminator?: Array<string>;
  isAttributeUpload?: boolean;
  hasValuesAssigned?: boolean;
  includeValues?: boolean;
  variableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  templateVersionId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
}

export interface EmploymentConditionLibraryCustomerServicePublishDocumentsContractActionsRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryDocumentGenerationPublishDocumentsModel?: EmploymentConditionLibraryDocumentGenerationPublishDocumentsModel;
}

export interface EmploymentConditionLibraryCustomerServiceQueryActivityStreamTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  page?: number;
  size?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryAttributesRequestParams {
  queryName?: string;
  queryCountry?: string;
  queryLegalEntity?: string;
  queryIsGlobal?: boolean;
  querySearchQuery?: string;
  queryDiscriminator?: Array<string>;
  queryIsAttributeUpload?: boolean;
  queryHasValuesAssigned?: boolean;
  queryIncludeValues?: boolean;
  queryVariableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  queryTemplateVersionId?: string;
  queryModule?: 'Default' | 'Restructuring' | 'Playground';
  queryEffectiveDate?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryByGidsEmployeesRequestParams {
  country: string;
  legalEntity: string;
  gids?: Array<string>;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryByTemplateEmployeesRequestParams {
  templateId: string;
  effectiveDate?: string;
  searchString?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryClauseCategoriesRequestParams {
  type: string;
  searchQuery?: string;
  cluster?: string;
  subject?: string;
  topic?: string;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  categoryQueryClusterValues?: Array<string>;
  categoryQueryClusterType?: string;
  categoryQuerySubjectValues?: Array<string>;
  categoryQuerySubjectType?: string;
  categoryQueryTopicValues?: Array<string>;
  categoryQueryTopicType?: string;
  pageablePage?: number;
  pageableSize?: number;
  parentId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryClausesRequestParams {
  countries?: Array<string>;
  legalEntities?: Array<string>;
  clusters?: Array<string>;
  subjects?: Array<string>;
  topics?: Array<string>;
  names?: Array<string>;
  clauseGroups?: Array<string>;
  search?: string;
  clauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  effectiveTo?: string;
  withContent?: boolean;
  localLanguage?: string;
  effectiveFrom?: string;
  isQueryingForTemplate?: boolean;
  effectiveDate?: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryContractActionsRequestParams {
  queryLegalEntities?: Array<string>;
  queryCountries?: Array<string>;
  queryDocumentType?: Array<'EmploymentContract' | 'Policy' | 'Addendum' | 'Contract'>;
  querySearch?: string;
  queryContractActionStatus?: Array<'Active' | 'Archived'>;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryContractAssignmentsContractActionsRequestParams {
  id: string;
  queryStatus?: Array<'Draft' | 'Published' | 'Signed' | 'Dropped' | 'Failed' | 'Creating'>;
  querySearchQuery?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryEmployeesRequestParams {
  searchString?: string;
  includeManagerInformation?: boolean;
  queryGid?: string;
  queryFullName?: string;
  queryCountry?: Array<string>;
  queryLegalEntity?: Array<string>;
  queryDataSource?: Array<string>;
  queryModule?: 'Default' | 'Restructuring' | 'Playground';
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
}

export interface EmploymentConditionLibraryCustomerServiceQueryFieldValueEmployeesRequestParams {
  fieldName: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4;
  gid?: string;
  fullName?: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  dataSource?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryFieldValueWithCountsClausesRequestParams {
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  country?: Array<string>;
  legalEntity?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryFieldValuesAttributesRequestParams {
  fieldName: string;
  name?: string;
  country?: string;
  legalEntity?: string;
  isGlobal?: boolean;
  searchQuery?: string;
  discriminator?: Array<string>;
  isAttributeUpload?: boolean;
  hasValuesAssigned?: boolean;
  includeValues?: boolean;
  variableType?: 'Text' | 'Number' | 'Date' | 'Boolean' | 'Country' | 'Currency' | 'Percentage';
  templateVersionId?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  effectiveDate?: string;
  page?: number;
  size?: number;
}

export interface EmploymentConditionLibraryCustomerServiceQueryFieldValuesContractActionsRequestParams {
  pageableRequestPage?: number;
  pageableRequestSize?: number;
  targetProperty?: 0 | 1 | 2;
  legalEntities?: Array<string>;
  countries?: Array<string>;
  documentType?: Array<'EmploymentContract' | 'Policy' | 'Addendum' | 'Contract'>;
  search?: string;
  contractActionStatus?: Array<'Active' | 'Archived'>;
}

export interface EmploymentConditionLibraryCustomerServiceQueryFieldValuesForClauseCreationClausesRequestParams {
  queryTargetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryClusters?: Array<string>;
  querySubjects?: Array<string>;
  queryTopics?: Array<string>;
  queryNames?: Array<string>;
  queryClauseGroups?: Array<string>;
  querySearch?: string;
  queryClauseStatus?: Array<'Draft' | 'Published' | 'Retired' | 'PendingApproval'>;
  queryEffectiveTo?: string;
  queryWithContent?: boolean;
  queryLocalLanguage?: string;
  queryEffectiveFrom?: string;
  queryIsQueryingForTemplate?: boolean;
  queryEffectiveDate?: string;
  pageablePage?: number;
  pageableSize?: number;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryFieldValuesTemplatesRequestParams {
  countries?: Array<string>;
  legalEntities?: Array<string>;
  isQueryingForDocumentGeneration?: boolean;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamClauseActivityStreamRequestParams {
  page?: number;
  size?: number;
  name?: string;
  userSearch?: string;
  eventOperation?: 'Created' | 'Updated' | 'Deleted';
  fromDate?: string;
  toDate?: string;
  changedProperty?: string;
  metadataItem?: string;
  country?: string;
  are?: string;
  eventTypes?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamTemplateActivityStreamRequestParams {
  page?: number;
  size?: number;
  name?: string;
  userSearch?: string;
  eventOperation?: 'Created' | 'Updated' | 'Deleted';
  fromDate?: string;
  toDate?: string;
  changedProperty?: string;
  metadataItem?: string;
  country?: string;
  are?: string;
  eventTypes?: Array<string>;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQuerySignatureAuthorizationRequestParams {
  legalEntity: string;
  pageablePage?: number;
  pageableSize?: number;
  searchQuery?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQuerySimulatedEmployeesEmployeesRequestParams {
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryEmployeesQuerySimulatedEmployeesModel?: EmploymentConditionLibraryEmployeesQuerySimulatedEmployeesModel;
}

export interface EmploymentConditionLibraryCustomerServiceQueryTemplatesRequestParams {
  queryCountries?: Array<string>;
  queryLegalEntities?: Array<string>;
  queryTemplateType?: Array<'EmploymentContract' | 'Policy' | 'Addendum' | 'Contract'>;
  queryClauseIds?: Array<string>;
  querySearch?: string;
  queryTemplateStatus?: Array<'Draft' | 'PendingApproval' | 'Published' | 'Retired'>;
  queryIsQueryingForDocumentGeneration?: boolean;
  queryApprover?: string;
  pageablePage?: number;
  pageableSize?: number;
  sortableOrderBy?: 'Asc' | 'Desc';
  sortableProperty?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceQueryUsersRequestParams {
  searchString?: string;
  firstname?: Array<string>;
  lastname?: Array<string>;
  middlename?: Array<string>;
  gid?: Array<string>;
  isApproverAuthorized?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
}

export interface EmploymentConditionLibraryCustomerServiceRejectClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseVersionsRejectClauseVersionModel?: EmploymentConditionLibraryClauseVersionsRejectClauseVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceRejectTemplateVersionsRequestParams {
  templateId: string;
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateVersionsRejectTemplateVersionModel?: EmploymentConditionLibraryTemplateVersionsRejectTemplateVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceRetireClauseClausesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClausesRetireClauseModel?: EmploymentConditionLibraryClausesRetireClauseModel;
}

export interface EmploymentConditionLibraryCustomerServiceRetireTemplatesRequestParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplatesRetireTemplateModel?: EmploymentConditionLibraryTemplatesRetireTemplateModel;
}

export interface EmploymentConditionLibraryCustomerServiceSendToApproverClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  sharedEmploymentConditionLibrarySendToApproverModel?: SharedEmploymentConditionLibrarySendToApproverModel;
}

export interface EmploymentConditionLibraryCustomerServiceSendToApproverTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  sharedEmploymentConditionLibrarySendToApproverModel?: SharedEmploymentConditionLibrarySendToApproverModel;
}

export interface EmploymentConditionLibraryCustomerServiceSimulateContentTemplateVersionSimulationRequestParams {
  versionId: string;
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateSimulationsSimulateTemplateContentModel?: EmploymentConditionLibraryTemplateSimulationsSimulateTemplateContentModel;
}

export interface EmploymentConditionLibraryCustomerServiceTransferClauseClausesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel?: EmploymentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel;
}

export interface EmploymentConditionLibraryCustomerServiceTransferTemplateTemplatesRequestParams {
  id: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel?: EmploymentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel;
}

export interface EmploymentConditionLibraryCustomerServiceUpdateClauseVersionsRequestParams {
  clauseId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryClauseVersionsUpdateClauseVersionModel?: EmploymentConditionLibraryClauseVersionsUpdateClauseVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceUpdateContentTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateVersionsUpdateTemplateVersionContentModel?: EmploymentConditionLibraryTemplateVersionsUpdateTemplateVersionContentModel;
}

export interface EmploymentConditionLibraryCustomerServiceUpdateTemplateRuleSetTemplatesRequestParams {
  templateId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplatesUpdateTemplateRuleSetModel?: EmploymentConditionLibraryTemplatesUpdateTemplateRuleSetModel;
}

export interface EmploymentConditionLibraryCustomerServiceUpdateTemplateVersionsRequestParams {
  templateId: string;
  versionId: string;
  module?: 'Default' | 'Restructuring' | 'Playground';
  employmentConditionLibraryTemplateVersionsUpdateTemplateVersionModel?: EmploymentConditionLibraryTemplateVersionsUpdateTemplateVersionModel;
}

export interface EmploymentConditionLibraryCustomerServiceValidateDocumentGenerationRequestParams {
  employmentConditionLibraryDocumentGenerationDocumentGenerationValidationRequestModel?: EmploymentConditionLibraryDocumentGenerationDocumentGenerationValidationRequestModel;
}

@Injectable({
  providedIn: 'root'
})
export class EmploymentConditionLibraryCustomerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public abortClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public abortClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public abortClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public abortClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling abortClauseVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling abortClauseVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/abort`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public abortTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public abortTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public abortTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public abortTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAbortTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling abortTemplateVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling abortTemplateVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/abort`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddAttachmentTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplateVersionSettingsTemplateVersionAttachmentModel>;
  public addAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddAttachmentTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplateVersionSettingsTemplateVersionAttachmentModel>>;
  public addAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddAttachmentTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplateVersionSettingsTemplateVersionAttachmentModel>>;
  public addAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddAttachmentTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling addAttachmentTemplateVersions.'
      );
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling addAttachmentTemplateVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateVersionSettingsCreateTemplateVersionAttachmentModel =
      requestParameters?.employmentConditionLibraryTemplateVersionSettingsCreateTemplateVersionAttachmentModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attachments`;
    return this.httpClient.request<EmploymentConditionLibraryTemplateVersionSettingsTemplateVersionAttachmentModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateVersionSettingsCreateTemplateVersionAttachmentModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addNewClauseLanguageClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddNewClauseLanguageClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseDetailsModel>;
  public addNewClauseLanguageClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddNewClauseLanguageClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public addNewClauseLanguageClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddNewClauseLanguageClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public addNewClauseLanguageClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceAddNewClauseLanguageClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling addNewClauseLanguageClauses.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClausesAddNewClauseLanguageModel =
      requestParameters?.employmentConditionLibraryClausesAddNewClauseLanguageModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/new-language`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseDetailsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClausesAddNewClauseLanguageModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public approveClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public approveClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public approveClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling approveClauseVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling approveClauseVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseVersionsApproveClauseVersionModel =
      requestParameters?.employmentConditionLibraryClauseVersionsApproveClauseVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approve`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseVersionsApproveClauseVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public approveTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public approveTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public approveTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public approveTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceApproveTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling approveTemplateVersions.');
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling approveTemplateVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateVersionsApproveTemplateVersionModel =
      requestParameters?.employmentConditionLibraryTemplateVersionsApproveTemplateVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approve`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateVersionsApproveTemplateVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public archiveContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceArchiveContractActionContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryContractActionContractActionDetailsModel>;
  public archiveContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceArchiveContractActionContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryContractActionContractActionDetailsModel>>;
  public archiveContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceArchiveContractActionContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryContractActionContractActionDetailsModel>>;
  public archiveContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceArchiveContractActionContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling archiveContractActionContractActions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/archive`;
    return this.httpClient.request<EmploymentConditionLibraryContractActionContractActionDetailsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeSignersForAssignmentContractAssignmentRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>;
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeSignersForAssignmentContractAssignmentRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>>;
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeSignersForAssignmentContractAssignmentRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>>;
  public changeSignersForAssignmentContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeSignersForAssignmentContractAssignmentRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling changeSignersForAssignmentContractAssignment.'
      );
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryContractAssignmentChangeSignersForAssignmentModel =
      requestParameters?.employmentConditionLibraryContractAssignmentChangeSignersForAssignmentModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/contract-assignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/signers`;
    return this.httpClient.request<EmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryContractAssignmentChangeSignersForAssignmentModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changeStatusForAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeStatusForAssignmentsContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public changeStatusForAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeStatusForAssignmentsContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public changeStatusForAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeStatusForAssignmentsContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public changeStatusForAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceChangeStatusForAssignmentsContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling changeStatusForAssignmentsContractActions.'
      );
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryContractActionChangeStatusForAssignmentsModel =
      requestParameters?.employmentConditionLibraryContractActionChangeStatusForAssignmentsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/change-status`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryContractActionChangeStatusForAssignmentsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkPermissionsContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCheckPermissionsContractAssignmentRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<string>>;
  public checkPermissionsContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCheckPermissionsContractAssignmentRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<string>>>;
  public checkPermissionsContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCheckPermissionsContractAssignmentRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<string>>>;
  public checkPermissionsContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCheckPermissionsContractAssignmentRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryContractAssignmentCheckPermissionsForDownloadModel =
      requestParameters?.employmentConditionLibraryContractAssignmentCheckPermissionsForDownloadModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/contract-assignments/check-permissions`;
    return this.httpClient.request<Array<string>>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employmentConditionLibraryContractAssignmentCheckPermissionsForDownloadModel,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseDetailsModel>;
  public createClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public createClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public createClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryClausesCreateClauseModel =
      requestParameters?.employmentConditionLibraryClausesCreateClauseModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseDetailsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClausesCreateClauseModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDraftClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClauseVersionsClauseVersionModel>;
  public createDraftClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public createDraftClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public createDraftClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling createDraftClauseVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseVersionsCreateClauseVersionDraftModel =
      requestParameters?.employmentConditionLibraryClauseVersionsCreateClauseVersionDraftModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions`;
    return this.httpClient.request<EmploymentConditionLibraryClauseVersionsClauseVersionModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseVersionsCreateClauseVersionDraftModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createDraftTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>;
  public createDraftTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public createDraftTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public createDraftTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateDraftTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling createDraftTemplateVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateVersionsCreateTemplateDraftVersionModel =
      requestParameters?.employmentConditionLibraryTemplateVersionsCreateTemplateDraftVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions`;
    return this.httpClient.request<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateVersionsCreateTemplateDraftVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplatesTemplateDetailsModel>;
  public createTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public createTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public createTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceCreateTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplatesCreateTemplateModel =
      requestParameters?.employmentConditionLibraryTemplatesCreateTemplateModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates`;
    return this.httpClient.request<EmploymentConditionLibraryTemplatesTemplateDetailsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplatesCreateTemplateModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteAttachmentTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteAttachmentTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteAttachmentTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteAttachmentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteAttachmentTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling deleteAttachmentTemplateVersions.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteAttachmentTemplateVersions.');
    }
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling deleteAttachmentTemplateVersions.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/attachments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClauseLanguagesClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseLanguagesClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseDetailsModel>;
  public deleteClauseLanguagesClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseLanguagesClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public deleteClauseLanguagesClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseLanguagesClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public deleteClauseLanguagesClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseLanguagesClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteClauseLanguagesClauses.');
    }
    const languageCodes = requestParameters?.languageCodes;
    if (languageCodes === null || languageCodes === undefined) {
      throw new Error(
        'Required parameter languageCodes was null or undefined when calling deleteClauseLanguagesClauses.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (languageCodes) {
      languageCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LanguageCodes');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/delete-language`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseDetailsModel>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public deleteClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling deleteClauseVersions.');
    }
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling deleteClauseVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public deleteTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDeleteTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling deleteTemplateVersions.');
    }
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling deleteTemplateVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public dropContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDropContractActionContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryContractActionContractActionDetailsModel>;
  public dropContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDropContractActionContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryContractActionContractActionDetailsModel>>;
  public dropContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDropContractActionContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryContractActionContractActionDetailsModel>>;
  public dropContractActionContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDropContractActionContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling dropContractActionContractActions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryContractActionContractActionDetailsModel>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateClauseClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseDetailsModel>;
  public duplicateClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateClauseClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public duplicateClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateClauseClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public duplicateClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateClauseClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling duplicateClauseClauses.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClausesDuplicateClauseModel =
      requestParameters?.employmentConditionLibraryClausesDuplicateClauseModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseDetailsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClausesDuplicateClauseModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplatesTemplateDetailsModel>;
  public duplicateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public duplicateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public duplicateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceDuplicateTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplatesDuplicateTemplateModel =
      requestParameters?.employmentConditionLibraryTemplatesDuplicateTemplateModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/duplicate`;
    return this.httpClient.request<EmploymentConditionLibraryTemplatesTemplateDetailsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplatesDuplicateTemplateModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BaseRedisEntity>;
  public exportClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BaseRedisEntity>>;
  public exportClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BaseRedisEntity>>;
  public exportClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryClausesExportClausesModel =
      requestParameters?.employmentConditionLibraryClausesExportClausesModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/export`;
    return this.httpClient.request<BaseRedisEntity>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employmentConditionLibraryClausesExportClausesModel,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportContractAssignmentRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportContractAssignmentRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportContractAssignmentRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportContractAssignment(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportContractAssignmentRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryContractAssignmentExportContractAssignmentsModel =
      requestParameters?.employmentConditionLibraryContractAssignmentExportContractAssignmentsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/contract-assignments/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryContractAssignmentExportContractAssignmentsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamClauseActivityStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamClauseActivityStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamClauseActivityStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamClauseActivityStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryClausesExportClauseActivitiesModel =
      requestParameters?.employmentConditionLibraryClausesExportClauseActivitiesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/activity-stream/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClausesExportClauseActivitiesModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryTemplatesExportTemplateActivitiesParameter =
      requestParameters?.employmentConditionLibraryTemplatesExportTemplateActivitiesParameter;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/activity-stream/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplatesExportTemplateActivitiesParameter,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTemplateAssociationsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplateAssociationsClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTemplateAssociationsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplateAssociationsClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTemplateAssociationsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplateAssociationsClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTemplateAssociationsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplateAssociationsClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryClausesExportClauseTemplateAssociationsModel =
      requestParameters?.employmentConditionLibraryClausesExportClauseTemplateAssociationsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/export/template-associations`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClausesExportClauseTemplateAssociationsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BaseRedisEntity>;
  public exportTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BaseRedisEntity>>;
  public exportTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BaseRedisEntity>>;
  public exportTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceExportTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplatesCreateTemplateExportModel =
      requestParameters?.employmentConditionLibraryTemplatesCreateTemplateExportModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/export`;
    return this.httpClient.request<BaseRedisEntity>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employmentConditionLibraryTemplatesCreateTemplateExportModel,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateContractActionContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateContractActionContentDocumentGenerationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SiemensEnergyCOINEmploymentConditionLibraryApiDtosCommonTemplateSimulationFilledTemplateContentResponse>;
  public generateContractActionContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateContractActionContentDocumentGenerationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SiemensEnergyCOINEmploymentConditionLibraryApiDtosCommonTemplateSimulationFilledTemplateContentResponse>
  >;
  public generateContractActionContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateContractActionContentDocumentGenerationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SiemensEnergyCOINEmploymentConditionLibraryApiDtosCommonTemplateSimulationFilledTemplateContentResponse>
  >;
  public generateContractActionContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateContractActionContentDocumentGenerationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const actionId = requestParameters?.actionId;
    if (actionId === null || actionId === undefined) {
      throw new Error(
        'Required parameter actionId was null or undefined when calling generateContractActionContentDocumentGeneration.'
      );
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling generateContractActionContentDocumentGeneration.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/document-generation/contract-actions/${this.configuration.encodeParam({ name: 'actionId', value: actionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/generate-content`;
    return this.httpClient.request<SiemensEnergyCOINEmploymentConditionLibraryApiDtosCommonTemplateSimulationFilledTemplateContentResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateDocumentGenerationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfDocumentGenerationMetadata>;
  public generateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateDocumentGenerationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfDocumentGenerationMetadata>>;
  public generateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateDocumentGenerationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfDocumentGenerationMetadata>>;
  public generateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGenerateDocumentGenerationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryDocumentGenerationGenerateNewDocumentsModel =
      requestParameters?.employmentConditionLibraryDocumentGenerationGenerateNewDocumentsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/document-generation`;
    return this.httpClient.request<TransactionStatusOfDocumentGenerationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryDocumentGenerationGenerateNewDocumentsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetActivityStreamForVersionClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>;
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetActivityStreamForVersionClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetActivityStreamForVersionClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public getActivityStreamForVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetActivityStreamForVersionClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error(
        'Required parameter clauseId was null or undefined when calling getActivityStreamForVersionClauseVersions.'
      );
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling getActivityStreamForVersionClauseVersions.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/activity-stream`;
    return this.httpClient.request<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAttributesTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetAttributesTemplateVersionSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryAttributeAssignmentsAttributeAssignmentsModel>;
  public getAttributesTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetAttributesTemplateVersionSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryAttributeAssignmentsAttributeAssignmentsModel>>;
  public getAttributesTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetAttributesTemplateVersionSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryAttributeAssignmentsAttributeAssignmentsModel>>;
  public getAttributesTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetAttributesTemplateVersionSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling getAttributesTemplateVersionSimulation.'
      );
    }
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling getAttributesTemplateVersionSimulation.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulation/attributes`;
    return this.httpClient.request<EmploymentConditionLibraryAttributeAssignmentsAttributeAssignmentsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCachedContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCachedContentDocumentGenerationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public getCachedContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCachedContentDocumentGenerationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public getCachedContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCachedContentDocumentGenerationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public getCachedContentDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCachedContentDocumentGenerationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const actionId = requestParameters?.actionId;
    if (actionId === null || actionId === undefined) {
      throw new Error(
        'Required parameter actionId was null or undefined when calling getCachedContentDocumentGeneration.'
      );
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling getCachedContentDocumentGeneration.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/document-generation/contract-actions/${this.configuration.encodeParam({ name: 'actionId', value: actionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClauseDetailsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseDetailsClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseDetailsModel>;
  public getClauseDetailsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseDetailsClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public getClauseDetailsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseDetailsClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public getClauseDetailsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseDetailsClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling getClauseDetailsClauses.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getClauseVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseVersionClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClauseVersionsClauseVersionModel>;
  public getClauseVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseVersionClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public getClauseVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseVersionClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public getClauseVersionClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetClauseVersionClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling getClauseVersionClauseVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling getClauseVersionClauseVersions.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryClauseVersionsClauseVersionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryContractActionContractActionDetailsModel>;
  public getContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryContractActionContractActionDetailsModel>>;
  public getContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryContractActionContractActionDetailsModel>>;
  public getContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getContractActions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryContractActionContractActionDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCountryAndAreCountsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCountryAndAreCountsContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryDocumentGenerationDocumentGenerationFieldValueWithCountsModel>;
  public getCountryAndAreCountsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCountryAndAreCountsContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryDocumentGenerationDocumentGenerationFieldValueWithCountsModel>>;
  public getCountryAndAreCountsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCountryAndAreCountsContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryDocumentGenerationDocumentGenerationFieldValueWithCountsModel>>;
  public getCountryAndAreCountsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetCountryAndAreCountsContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const countries = requestParameters?.countries;
    const legalEntities = requestParameters?.legalEntities;
    const contractActionStatus = requestParameters?.contractActionStatus;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (countries) {
      countries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Countries');
      });
    }
    if (legalEntities) {
      legalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntities');
      });
    }
    if (contractActionStatus) {
      contractActionStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractActionStatus');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/fields/count`;
    return this.httpClient.request<EmploymentConditionLibraryDocumentGenerationDocumentGenerationFieldValueWithCountsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLatestClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClauseVersionsClauseVersionModel>;
  public getLatestClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public getLatestClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public getLatestClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling getLatestClauseVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/latest`;
    return this.httpClient.request<EmploymentConditionLibraryClauseVersionsClauseVersionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLatestTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>;
  public getLatestTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public getLatestTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public getLatestTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetLatestTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling getLatestTemplateVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/latest`;
    return this.httpClient.request<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetScopeAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedEntitySearchScopeModel>;
  public getScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetScopeAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedEntitySearchScopeModel>>;
  public getScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetScopeAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedEntitySearchScopeModel>>;
  public getScopeAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetScopeAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const name = requestParameters?.name;
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const isGlobal = requestParameters?.isGlobal;
    const searchQuery = requestParameters?.searchQuery;
    const discriminator = requestParameters?.discriminator;
    const isAttributeUpload = requestParameters?.isAttributeUpload;
    const hasValuesAssigned = requestParameters?.hasValuesAssigned;
    const includeValues = requestParameters?.includeValues;
    const variableType = requestParameters?.variableType;
    const templateVersionId = requestParameters?.templateVersionId;
    const module = requestParameters?.module;
    const effectiveDate = requestParameters?.effectiveDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (legalEntity !== undefined && legalEntity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>legalEntity, 'LegalEntity');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (discriminator) {
      discriminator.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Discriminator');
      });
    }
    if (isAttributeUpload !== undefined && isAttributeUpload !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isAttributeUpload,
        'IsAttributeUpload'
      );
    }
    if (hasValuesAssigned !== undefined && hasValuesAssigned !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasValuesAssigned,
        'HasValuesAssigned'
      );
    }
    if (includeValues !== undefined && includeValues !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>includeValues, 'IncludeValues');
    }
    if (variableType !== undefined && variableType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>variableType, 'VariableType');
    }
    if (templateVersionId !== undefined && templateVersionId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>templateVersionId,
        'TemplateVersionId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (effectiveDate !== undefined && effectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveDate, 'EffectiveDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/attributes/scope`;
    return this.httpClient.request<SharedEntitySearchScopeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetSimulatedContentTemplateVersionSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<ConclusiveTransactionStatusOfTemplateSimulationMetadata>;
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetSimulatedContentTemplateVersionSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetSimulatedContentTemplateVersionSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public getSimulatedContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetSimulatedContentTemplateVersionSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling getSimulatedContentTemplateVersionSimulation.'
      );
    }
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling getSimulatedContentTemplateVersionSimulation.'
      );
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulation/content-status`;
    return this.httpClient.request<ConclusiveTransactionStatusOfTemplateSimulationMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>;
  public getTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public getTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public getTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling getTemplateVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling getTemplateVersions.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplatesTemplateDetailsModel>;
  public getTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public getTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public getTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling getTemplates.');
    }
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryTemplatesTemplateDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetValuesByIdAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public getValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetValuesByIdAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public getValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetValuesByIdAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public getValuesByIdAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceGetValuesByIdAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getValuesByIdAttributes.');
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const name = requestParameters?.name;
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const isGlobal = requestParameters?.isGlobal;
    const searchQuery = requestParameters?.searchQuery;
    const discriminator = requestParameters?.discriminator;
    const isAttributeUpload = requestParameters?.isAttributeUpload;
    const hasValuesAssigned = requestParameters?.hasValuesAssigned;
    const includeValues = requestParameters?.includeValues;
    const variableType = requestParameters?.variableType;
    const templateVersionId = requestParameters?.templateVersionId;
    const module = requestParameters?.module;
    const effectiveDate = requestParameters?.effectiveDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (legalEntity !== undefined && legalEntity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>legalEntity, 'LegalEntity');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (discriminator) {
      discriminator.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Discriminator');
      });
    }
    if (isAttributeUpload !== undefined && isAttributeUpload !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isAttributeUpload,
        'IsAttributeUpload'
      );
    }
    if (hasValuesAssigned !== undefined && hasValuesAssigned !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasValuesAssigned,
        'HasValuesAssigned'
      );
    }
    if (includeValues !== undefined && includeValues !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>includeValues, 'IncludeValues');
    }
    if (variableType !== undefined && variableType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>variableType, 'VariableType');
    }
    if (templateVersionId !== undefined && templateVersionId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>templateVersionId,
        'TemplateVersionId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (effectiveDate !== undefined && effectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveDate, 'EffectiveDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/attributes/values/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishDocumentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServicePublishDocumentsContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public publishDocumentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServicePublishDocumentsContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public publishDocumentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServicePublishDocumentsContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public publishDocumentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServicePublishDocumentsContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling publishDocumentsContractActions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryDocumentGenerationPublishDocumentsModel =
      requestParameters?.employmentConditionLibraryDocumentGenerationPublishDocumentsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryDocumentGenerationPublishDocumentsModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryActivityStreamTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryActivityStreamTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>;
  public queryActivityStreamTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryActivityStreamTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public queryActivityStreamTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryActivityStreamTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public queryActivityStreamTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryActivityStreamTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling queryActivityStreamTemplateVersions.'
      );
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling queryActivityStreamTemplateVersions.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/activity-stream`;
    return this.httpClient.request<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryAttributesAttributeLightModel>;
  public queryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryAttributesAttributeLightModel>>;
  public queryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryAttributesAttributeLightModel>>;
  public queryAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryName = requestParameters?.queryName;
    const queryCountry = requestParameters?.queryCountry;
    const queryLegalEntity = requestParameters?.queryLegalEntity;
    const queryIsGlobal = requestParameters?.queryIsGlobal;
    const querySearchQuery = requestParameters?.querySearchQuery;
    const queryDiscriminator = requestParameters?.queryDiscriminator;
    const queryIsAttributeUpload = requestParameters?.queryIsAttributeUpload;
    const queryHasValuesAssigned = requestParameters?.queryHasValuesAssigned;
    const queryIncludeValues = requestParameters?.queryIncludeValues;
    const queryVariableType = requestParameters?.queryVariableType;
    const queryTemplateVersionId = requestParameters?.queryTemplateVersionId;
    const queryModule = requestParameters?.queryModule;
    const queryEffectiveDate = requestParameters?.queryEffectiveDate;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryName !== undefined && queryName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryName, 'Query.Name');
    }
    if (queryCountry !== undefined && queryCountry !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryCountry, 'Query.Country');
    }
    if (queryLegalEntity !== undefined && queryLegalEntity !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLegalEntity,
        'Query.LegalEntity'
      );
    }
    if (queryIsGlobal !== undefined && queryIsGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsGlobal, 'Query.IsGlobal');
    }
    if (querySearchQuery !== undefined && querySearchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>querySearchQuery,
        'Query.SearchQuery'
      );
    }
    if (queryDiscriminator) {
      queryDiscriminator.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Discriminator');
      });
    }
    if (queryIsAttributeUpload !== undefined && queryIsAttributeUpload !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsAttributeUpload,
        'Query.IsAttributeUpload'
      );
    }
    if (queryHasValuesAssigned !== undefined && queryHasValuesAssigned !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHasValuesAssigned,
        'Query.HasValuesAssigned'
      );
    }
    if (queryIncludeValues !== undefined && queryIncludeValues !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIncludeValues,
        'Query.IncludeValues'
      );
    }
    if (queryVariableType !== undefined && queryVariableType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryVariableType,
        'Query.VariableType'
      );
    }
    if (queryTemplateVersionId !== undefined && queryTemplateVersionId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTemplateVersionId,
        'Query.TemplateVersionId'
      );
    }
    if (queryModule !== undefined && queryModule !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryModule, 'Query.Module');
    }
    if (queryEffectiveDate !== undefined && queryEffectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveDate,
        'Query.EffectiveDate'
      );
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/attributes`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryAttributesAttributeLightModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByGidsEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public queryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByGidsEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByGidsEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryByGidsEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByGidsEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const country = requestParameters?.country;
    if (country === null || country === undefined) {
      throw new Error('Required parameter country was null or undefined when calling queryByGidsEmployees.');
    }
    const legalEntity = requestParameters?.legalEntity;
    if (legalEntity === null || legalEntity === undefined) {
      throw new Error('Required parameter legalEntity was null or undefined when calling queryByGidsEmployees.');
    }
    const gids = requestParameters?.gids;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (legalEntity !== undefined && legalEntity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>legalEntity, 'LegalEntity');
    }
    if (gids) {
      gids.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gids');
      });
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/employees/gids`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByTemplateEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByTemplateEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public queryByTemplateEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByTemplateEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryByTemplateEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByTemplateEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryByTemplateEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryByTemplateEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling queryByTemplateEmployees.');
    }
    const effectiveDate = requestParameters?.effectiveDate;
    const searchString = requestParameters?.searchString;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (templateId !== undefined && templateId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>templateId, 'TemplateId');
    }
    if (effectiveDate !== undefined && effectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveDate, 'EffectiveDate');
    }
    if (searchString !== undefined && searchString !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchString, 'SearchString');
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/employees/template`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClauseCategoriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClauseCategoriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClauseCategoriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryClauseCategories(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClauseCategoriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const type = requestParameters?.type;
    if (type === null || type === undefined) {
      throw new Error('Required parameter type was null or undefined when calling queryClauseCategories.');
    }
    const searchQuery = requestParameters?.searchQuery;
    const cluster = requestParameters?.cluster;
    const subject = requestParameters?.subject;
    const topic = requestParameters?.topic;
    const queryCountries = requestParameters?.queryCountries;
    const queryLegalEntities = requestParameters?.queryLegalEntities;
    const queryClusters = requestParameters?.queryClusters;
    const querySubjects = requestParameters?.querySubjects;
    const queryTopics = requestParameters?.queryTopics;
    const queryNames = requestParameters?.queryNames;
    const queryClauseGroups = requestParameters?.queryClauseGroups;
    const querySearch = requestParameters?.querySearch;
    const queryClauseStatus = requestParameters?.queryClauseStatus;
    const queryEffectiveTo = requestParameters?.queryEffectiveTo;
    const queryWithContent = requestParameters?.queryWithContent;
    const queryLocalLanguage = requestParameters?.queryLocalLanguage;
    const queryEffectiveFrom = requestParameters?.queryEffectiveFrom;
    const queryIsQueryingForTemplate = requestParameters?.queryIsQueryingForTemplate;
    const queryEffectiveDate = requestParameters?.queryEffectiveDate;
    const categoryQueryClusterValues = requestParameters?.categoryQueryClusterValues;
    const categoryQueryClusterType = requestParameters?.categoryQueryClusterType;
    const categoryQuerySubjectValues = requestParameters?.categoryQuerySubjectValues;
    const categoryQuerySubjectType = requestParameters?.categoryQuerySubjectType;
    const categoryQueryTopicValues = requestParameters?.categoryQueryTopicValues;
    const categoryQueryTopicType = requestParameters?.categoryQueryTopicType;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const parentId = requestParameters?.parentId;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (type !== undefined && type !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>type, 'Type');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (cluster !== undefined && cluster !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>cluster, 'Cluster');
    }
    if (subject !== undefined && subject !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subject, 'Subject');
    }
    if (topic !== undefined && topic !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>topic, 'Topic');
    }
    if (queryCountries) {
      queryCountries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Countries');
      });
    }
    if (queryLegalEntities) {
      queryLegalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntities');
      });
    }
    if (queryClusters) {
      queryClusters.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Clusters');
      });
    }
    if (querySubjects) {
      querySubjects.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Subjects');
      });
    }
    if (queryTopics) {
      queryTopics.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Topics');
      });
    }
    if (queryNames) {
      queryNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Names');
      });
    }
    if (queryClauseGroups) {
      queryClauseGroups.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseGroups');
      });
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryClauseStatus) {
      queryClauseStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseStatus');
      });
    }
    if (queryEffectiveTo !== undefined && queryEffectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveTo,
        'Query.EffectiveTo'
      );
    }
    if (queryWithContent !== undefined && queryWithContent !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryWithContent,
        'Query.WithContent'
      );
    }
    if (queryLocalLanguage !== undefined && queryLocalLanguage !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLocalLanguage,
        'Query.LocalLanguage'
      );
    }
    if (queryEffectiveFrom !== undefined && queryEffectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveFrom,
        'Query.EffectiveFrom'
      );
    }
    if (queryIsQueryingForTemplate !== undefined && queryIsQueryingForTemplate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsQueryingForTemplate,
        'Query.IsQueryingForTemplate'
      );
    }
    if (queryEffectiveDate !== undefined && queryEffectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveDate,
        'Query.EffectiveDate'
      );
    }
    if (categoryQueryClusterValues) {
      categoryQueryClusterValues.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CategoryQuery.Cluster.Values'
        );
      });
    }
    if (categoryQueryClusterType !== undefined && categoryQueryClusterType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>categoryQueryClusterType,
        'CategoryQuery.Cluster.Type'
      );
    }
    if (categoryQuerySubjectValues) {
      categoryQuerySubjectValues.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CategoryQuery.Subject.Values'
        );
      });
    }
    if (categoryQuerySubjectType !== undefined && categoryQuerySubjectType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>categoryQuerySubjectType,
        'CategoryQuery.Subject.Type'
      );
    }
    if (categoryQueryTopicValues) {
      categoryQueryTopicValues.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CategoryQuery.Topic.Values'
        );
      });
    }
    if (categoryQueryTopicType !== undefined && categoryQueryTopicType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>categoryQueryTopicType,
        'CategoryQuery.Topic.Type'
      );
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (parentId !== undefined && parentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentId, 'ParentId');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clause-categories`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryClausesClauseDetailsLightModel>;
  public queryClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryClausesClauseDetailsLightModel>>;
  public queryClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryClausesClauseDetailsLightModel>>;
  public queryClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const countries = requestParameters?.countries;
    const legalEntities = requestParameters?.legalEntities;
    const clusters = requestParameters?.clusters;
    const subjects = requestParameters?.subjects;
    const topics = requestParameters?.topics;
    const names = requestParameters?.names;
    const clauseGroups = requestParameters?.clauseGroups;
    const search = requestParameters?.search;
    const clauseStatus = requestParameters?.clauseStatus;
    const effectiveTo = requestParameters?.effectiveTo;
    const withContent = requestParameters?.withContent;
    const localLanguage = requestParameters?.localLanguage;
    const effectiveFrom = requestParameters?.effectiveFrom;
    const isQueryingForTemplate = requestParameters?.isQueryingForTemplate;
    const effectiveDate = requestParameters?.effectiveDate;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (countries) {
      countries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Countries');
      });
    }
    if (legalEntities) {
      legalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntities');
      });
    }
    if (clusters) {
      clusters.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Clusters');
      });
    }
    if (subjects) {
      subjects.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Subjects');
      });
    }
    if (topics) {
      topics.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Topics');
      });
    }
    if (names) {
      names.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Names');
      });
    }
    if (clauseGroups) {
      clauseGroups.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ClauseGroups');
      });
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (clauseStatus) {
      clauseStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ClauseStatus');
      });
    }
    if (effectiveTo !== undefined && effectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveTo, 'EffectiveTo');
    }
    if (withContent !== undefined && withContent !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>withContent, 'WithContent');
    }
    if (localLanguage !== undefined && localLanguage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>localLanguage, 'LocalLanguage');
    }
    if (effectiveFrom !== undefined && effectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveFrom, 'EffectiveFrom');
    }
    if (isQueryingForTemplate !== undefined && isQueryingForTemplate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isQueryingForTemplate,
        'IsQueryingForTemplate'
      );
    }
    if (effectiveDate !== undefined && effectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveDate, 'EffectiveDate');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryClausesClauseDetailsLightModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryContractActionContractActionLightModel>;
  public queryContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryContractActionContractActionLightModel>>;
  public queryContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryContractActionContractActionLightModel>>;
  public queryContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryLegalEntities = requestParameters?.queryLegalEntities;
    const queryCountries = requestParameters?.queryCountries;
    const queryDocumentType = requestParameters?.queryDocumentType;
    const querySearch = requestParameters?.querySearch;
    const queryContractActionStatus = requestParameters?.queryContractActionStatus;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryLegalEntities) {
      queryLegalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntities');
      });
    }
    if (queryCountries) {
      queryCountries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Countries');
      });
    }
    if (queryDocumentType) {
      queryDocumentType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.DocumentType');
      });
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryContractActionStatus) {
      queryContractActionStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ContractActionStatus'
        );
      });
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryContractActionContractActionLightModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryContractAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractAssignmentsContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>;
  public queryContractAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractAssignmentsContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfEmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>
  >;
  public queryContractAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractAssignmentsContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>>;
  public queryContractAssignmentsContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryContractAssignmentsContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling queryContractAssignmentsContractActions.'
      );
    }
    const queryStatus = requestParameters?.queryStatus;
    const querySearchQuery = requestParameters?.querySearchQuery;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryStatus) {
      queryStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Status');
      });
    }
    if (querySearchQuery !== undefined && querySearchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>querySearchQuery,
        'Query.SearchQuery'
      );
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/assignments`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryContractAssignmentContractAssignmentLightModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public queryEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const searchString = requestParameters?.searchString;
    const includeManagerInformation = requestParameters?.includeManagerInformation;
    const queryGid = requestParameters?.queryGid;
    const queryFullName = requestParameters?.queryFullName;
    const queryCountry = requestParameters?.queryCountry;
    const queryLegalEntity = requestParameters?.queryLegalEntity;
    const queryDataSource = requestParameters?.queryDataSource;
    const queryModule = requestParameters?.queryModule;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const module = requestParameters?.module;
    const effectiveDate = requestParameters?.effectiveDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (searchString !== undefined && searchString !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchString, 'SearchString');
    }
    if (includeManagerInformation !== undefined && includeManagerInformation !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>includeManagerInformation,
        'IncludeManagerInformation'
      );
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFullName !== undefined && queryFullName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFullName, 'Query.FullName');
    }
    if (queryCountry) {
      queryCountry.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Country');
      });
    }
    if (queryLegalEntity) {
      queryLegalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntity');
      });
    }
    if (queryDataSource) {
      queryDataSource.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.DataSource');
      });
    }
    if (queryModule !== undefined && queryModule !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryModule, 'Query.Module');
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (effectiveDate !== undefined && effectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveDate, 'EffectiveDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/employees`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<string>>;
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValueEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    if (fieldName === null || fieldName === undefined) {
      throw new Error('Required parameter fieldName was null or undefined when calling queryFieldValueEmployees.');
    }
    const targetProperty = requestParameters?.targetProperty;
    const gid = requestParameters?.gid;
    const fullName = requestParameters?.fullName;
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const dataSource = requestParameters?.dataSource;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (fullName !== undefined && fullName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fullName, 'FullName');
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (dataSource) {
      dataSource.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DataSource');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/employees/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValueWithCountsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueWithCountsClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseFieldValueWithCountsModel>;
  public queryFieldValueWithCountsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueWithCountsClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseFieldValueWithCountsModel>>;
  public queryFieldValueWithCountsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueWithCountsClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseFieldValueWithCountsModel>>;
  public queryFieldValueWithCountsClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValueWithCountsClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryCountries = requestParameters?.queryCountries;
    const queryLegalEntities = requestParameters?.queryLegalEntities;
    const queryClusters = requestParameters?.queryClusters;
    const querySubjects = requestParameters?.querySubjects;
    const queryTopics = requestParameters?.queryTopics;
    const queryNames = requestParameters?.queryNames;
    const queryClauseGroups = requestParameters?.queryClauseGroups;
    const querySearch = requestParameters?.querySearch;
    const queryClauseStatus = requestParameters?.queryClauseStatus;
    const queryEffectiveTo = requestParameters?.queryEffectiveTo;
    const queryWithContent = requestParameters?.queryWithContent;
    const queryLocalLanguage = requestParameters?.queryLocalLanguage;
    const queryEffectiveFrom = requestParameters?.queryEffectiveFrom;
    const queryIsQueryingForTemplate = requestParameters?.queryIsQueryingForTemplate;
    const queryEffectiveDate = requestParameters?.queryEffectiveDate;
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryCountries) {
      queryCountries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Countries');
      });
    }
    if (queryLegalEntities) {
      queryLegalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntities');
      });
    }
    if (queryClusters) {
      queryClusters.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Clusters');
      });
    }
    if (querySubjects) {
      querySubjects.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Subjects');
      });
    }
    if (queryTopics) {
      queryTopics.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Topics');
      });
    }
    if (queryNames) {
      queryNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Names');
      });
    }
    if (queryClauseGroups) {
      queryClauseGroups.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseGroups');
      });
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryClauseStatus) {
      queryClauseStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseStatus');
      });
    }
    if (queryEffectiveTo !== undefined && queryEffectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveTo,
        'Query.EffectiveTo'
      );
    }
    if (queryWithContent !== undefined && queryWithContent !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryWithContent,
        'Query.WithContent'
      );
    }
    if (queryLocalLanguage !== undefined && queryLocalLanguage !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLocalLanguage,
        'Query.LocalLanguage'
      );
    }
    if (queryEffectiveFrom !== undefined && queryEffectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveFrom,
        'Query.EffectiveFrom'
      );
    }
    if (queryIsQueryingForTemplate !== undefined && queryIsQueryingForTemplate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsQueryingForTemplate,
        'Query.IsQueryingForTemplate'
      );
    }
    if (queryEffectiveDate !== undefined && queryEffectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveDate,
        'Query.EffectiveDate'
      );
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (legalEntity) {
      legalEntity.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntity');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/fields/count`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseFieldValueWithCountsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesAttributesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesAttributesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesAttributesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesAttributes(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesAttributesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const fieldName = requestParameters?.fieldName;
    if (fieldName === null || fieldName === undefined) {
      throw new Error('Required parameter fieldName was null or undefined when calling queryFieldValuesAttributes.');
    }
    const name = requestParameters?.name;
    const country = requestParameters?.country;
    const legalEntity = requestParameters?.legalEntity;
    const isGlobal = requestParameters?.isGlobal;
    const searchQuery = requestParameters?.searchQuery;
    const discriminator = requestParameters?.discriminator;
    const isAttributeUpload = requestParameters?.isAttributeUpload;
    const hasValuesAssigned = requestParameters?.hasValuesAssigned;
    const includeValues = requestParameters?.includeValues;
    const variableType = requestParameters?.variableType;
    const templateVersionId = requestParameters?.templateVersionId;
    const module = requestParameters?.module;
    const effectiveDate = requestParameters?.effectiveDate;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (legalEntity !== undefined && legalEntity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>legalEntity, 'LegalEntity');
    }
    if (isGlobal !== undefined && isGlobal !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isGlobal, 'IsGlobal');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (discriminator) {
      discriminator.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Discriminator');
      });
    }
    if (isAttributeUpload !== undefined && isAttributeUpload !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isAttributeUpload,
        'IsAttributeUpload'
      );
    }
    if (hasValuesAssigned !== undefined && hasValuesAssigned !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hasValuesAssigned,
        'HasValuesAssigned'
      );
    }
    if (includeValues !== undefined && includeValues !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>includeValues, 'IncludeValues');
    }
    if (variableType !== undefined && variableType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>variableType, 'VariableType');
    }
    if (templateVersionId !== undefined && templateVersionId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>templateVersionId,
        'TemplateVersionId'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }
    if (effectiveDate !== undefined && effectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>effectiveDate, 'EffectiveDate');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/attributes/field-values/${this.configuration.encodeParam({ name: 'fieldName', value: fieldName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesContractActionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesContractActionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesContractActionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesContractActions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesContractActionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pageableRequestPage = requestParameters?.pageableRequestPage;
    const pageableRequestSize = requestParameters?.pageableRequestSize;
    const targetProperty = requestParameters?.targetProperty;
    const legalEntities = requestParameters?.legalEntities;
    const countries = requestParameters?.countries;
    const documentType = requestParameters?.documentType;
    const search = requestParameters?.search;
    const contractActionStatus = requestParameters?.contractActionStatus;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pageableRequestPage !== undefined && pageableRequestPage !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>pageableRequestPage,
        'PageableRequest.Page'
      );
    }
    if (pageableRequestSize !== undefined && pageableRequestSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>pageableRequestSize,
        'PageableRequest.Size'
      );
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (legalEntities) {
      legalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntities');
      });
    }
    if (countries) {
      countries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Countries');
      });
    }
    if (documentType) {
      documentType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DocumentType');
      });
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (contractActionStatus) {
      contractActionStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractActionStatus');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/folders/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesForClauseCreationClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedFieldValuesModel>;
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesForClauseCreationClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedFieldValuesModel>>;
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesForClauseCreationClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedFieldValuesModel>>;
  public queryFieldValuesForClauseCreationClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesForClauseCreationClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryCountries = requestParameters?.queryCountries;
    const queryLegalEntities = requestParameters?.queryLegalEntities;
    const queryClusters = requestParameters?.queryClusters;
    const querySubjects = requestParameters?.querySubjects;
    const queryTopics = requestParameters?.queryTopics;
    const queryNames = requestParameters?.queryNames;
    const queryClauseGroups = requestParameters?.queryClauseGroups;
    const querySearch = requestParameters?.querySearch;
    const queryClauseStatus = requestParameters?.queryClauseStatus;
    const queryEffectiveTo = requestParameters?.queryEffectiveTo;
    const queryWithContent = requestParameters?.queryWithContent;
    const queryLocalLanguage = requestParameters?.queryLocalLanguage;
    const queryEffectiveFrom = requestParameters?.queryEffectiveFrom;
    const queryIsQueryingForTemplate = requestParameters?.queryIsQueryingForTemplate;
    const queryEffectiveDate = requestParameters?.queryEffectiveDate;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryCountries) {
      queryCountries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Countries');
      });
    }
    if (queryLegalEntities) {
      queryLegalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntities');
      });
    }
    if (queryClusters) {
      queryClusters.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Clusters');
      });
    }
    if (querySubjects) {
      querySubjects.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Subjects');
      });
    }
    if (queryTopics) {
      queryTopics.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Topics');
      });
    }
    if (queryNames) {
      queryNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Names');
      });
    }
    if (queryClauseGroups) {
      queryClauseGroups.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseGroups');
      });
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryClauseStatus) {
      queryClauseStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseStatus');
      });
    }
    if (queryEffectiveTo !== undefined && queryEffectiveTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveTo,
        'Query.EffectiveTo'
      );
    }
    if (queryWithContent !== undefined && queryWithContent !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryWithContent,
        'Query.WithContent'
      );
    }
    if (queryLocalLanguage !== undefined && queryLocalLanguage !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLocalLanguage,
        'Query.LocalLanguage'
      );
    }
    if (queryEffectiveFrom !== undefined && queryEffectiveFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveFrom,
        'Query.EffectiveFrom'
      );
    }
    if (queryIsQueryingForTemplate !== undefined && queryIsQueryingForTemplate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsQueryingForTemplate,
        'Query.IsQueryingForTemplate'
      );
    }
    if (queryEffectiveDate !== undefined && queryEffectiveDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryEffectiveDate,
        'Query.EffectiveDate'
      );
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/fields`;
    return this.httpClient.request<SharedFieldValuesModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplatesTemplateFieldValueWithCountsModel>;
  public queryFieldValuesTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplatesTemplateFieldValueWithCountsModel>>;
  public queryFieldValuesTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplatesTemplateFieldValueWithCountsModel>>;
  public queryFieldValuesTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFieldValuesTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const countries = requestParameters?.countries;
    const legalEntities = requestParameters?.legalEntities;
    const isQueryingForDocumentGeneration = requestParameters?.isQueryingForDocumentGeneration;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (countries) {
      countries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Countries');
      });
    }
    if (legalEntities) {
      legalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LegalEntities');
      });
    }
    if (isQueryingForDocumentGeneration !== undefined && isQueryingForDocumentGeneration !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isQueryingForDocumentGeneration,
        'IsQueryingForDocumentGeneration'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/fields/count`;
    return this.httpClient.request<EmploymentConditionLibraryTemplatesTemplateFieldValueWithCountsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamClauseActivityStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>;
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamClauseActivityStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamClauseActivityStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public queryFilteredActivityStreamClauseActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamClauseActivityStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const name = requestParameters?.name;
    const userSearch = requestParameters?.userSearch;
    const eventOperation = requestParameters?.eventOperation;
    const fromDate = requestParameters?.fromDate;
    const toDate = requestParameters?.toDate;
    const changedProperty = requestParameters?.changedProperty;
    const metadataItem = requestParameters?.metadataItem;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const eventTypes = requestParameters?.eventTypes;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (userSearch !== undefined && userSearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userSearch, 'UserSearch');
    }
    if (eventOperation !== undefined && eventOperation !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>eventOperation, 'EventOperation');
    }
    if (fromDate !== undefined && fromDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fromDate, 'FromDate');
    }
    if (toDate !== undefined && toDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>toDate, 'ToDate');
    }
    if (changedProperty !== undefined && changedProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>changedProperty, 'ChangedProperty');
    }
    if (metadataItem !== undefined && metadataItem !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metadataItem, 'MetadataItem');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (are !== undefined && are !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>are, 'Are');
    }
    if (eventTypes) {
      eventTypes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'EventTypes');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/activity-stream/filtered`;
    return this.httpClient.request<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>;
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>>;
  public queryFilteredActivityStreamTemplateActivityStream(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryFilteredActivityStreamTemplateActivityStreamRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const name = requestParameters?.name;
    const userSearch = requestParameters?.userSearch;
    const eventOperation = requestParameters?.eventOperation;
    const fromDate = requestParameters?.fromDate;
    const toDate = requestParameters?.toDate;
    const changedProperty = requestParameters?.changedProperty;
    const metadataItem = requestParameters?.metadataItem;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const eventTypes = requestParameters?.eventTypes;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (userSearch !== undefined && userSearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>userSearch, 'UserSearch');
    }
    if (eventOperation !== undefined && eventOperation !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>eventOperation, 'EventOperation');
    }
    if (fromDate !== undefined && fromDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fromDate, 'FromDate');
    }
    if (toDate !== undefined && toDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>toDate, 'ToDate');
    }
    if (changedProperty !== undefined && changedProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>changedProperty, 'ChangedProperty');
    }
    if (metadataItem !== undefined && metadataItem !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>metadataItem, 'MetadataItem');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (are !== undefined && are !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>are, 'Are');
    }
    if (eventTypes) {
      eventTypes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'EventTypes');
      });
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/activity-stream/filtered`;
    return this.httpClient.request<SharedPageModelOfActivityStreamsActivityStreamModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySignatureAuthorization(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySignatureAuthorizationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>;
  public querySignatureAuthorization(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySignatureAuthorizationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>>;
  public querySignatureAuthorization(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySignatureAuthorizationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>>;
  public querySignatureAuthorization(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySignatureAuthorizationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const legalEntity = requestParameters?.legalEntity;
    if (legalEntity === null || legalEntity === undefined) {
      throw new Error('Required parameter legalEntity was null or undefined when calling querySignatureAuthorization.');
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const searchQuery = requestParameters?.searchQuery;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (legalEntity !== undefined && legalEntity !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>legalEntity, 'LegalEntity');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/signature-authorizations`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibrarySignatureAuthorizationsSignerEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySimulatedEmployeesEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>;
  public querySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySimulatedEmployeesEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public querySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySimulatedEmployeesEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>>;
  public querySimulatedEmployeesEmployees(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQuerySimulatedEmployeesEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const module = requestParameters?.module;
    const employmentConditionLibraryEmployeesQuerySimulatedEmployeesModel =
      requestParameters?.employmentConditionLibraryEmployeesQuerySimulatedEmployeesModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/employees/simulate`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryEmployeesEclEmployeeModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryEmployeesQuerySimulatedEmployeesModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryTemplatesTemplateDetailsLightModel>;
  public queryTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryTemplatesTemplateDetailsLightModel>>;
  public queryTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryTemplatesTemplateDetailsLightModel>>;
  public queryTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryCountries = requestParameters?.queryCountries;
    const queryLegalEntities = requestParameters?.queryLegalEntities;
    const queryTemplateType = requestParameters?.queryTemplateType;
    const queryClauseIds = requestParameters?.queryClauseIds;
    const querySearch = requestParameters?.querySearch;
    const queryTemplateStatus = requestParameters?.queryTemplateStatus;
    const queryIsQueryingForDocumentGeneration = requestParameters?.queryIsQueryingForDocumentGeneration;
    const queryApprover = requestParameters?.queryApprover;
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortableOrderBy = requestParameters?.sortableOrderBy;
    const sortableProperty = requestParameters?.sortableProperty;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryCountries) {
      queryCountries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Countries');
      });
    }
    if (queryLegalEntities) {
      queryLegalEntities.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LegalEntities');
      });
    }
    if (queryTemplateType) {
      queryTemplateType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TemplateType');
      });
    }
    if (queryClauseIds) {
      queryClauseIds.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ClauseIds');
      });
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryTemplateStatus) {
      queryTemplateStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TemplateStatus');
      });
    }
    if (queryIsQueryingForDocumentGeneration !== undefined && queryIsQueryingForDocumentGeneration !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsQueryingForDocumentGeneration,
        'Query.IsQueryingForDocumentGeneration'
      );
    }
    if (queryApprover !== undefined && queryApprover !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryApprover, 'Query.Approver');
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortableOrderBy !== undefined && sortableOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortableOrderBy, 'Sortable.OrderBy');
    }
    if (sortableProperty !== undefined && sortableProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>sortableProperty,
        'Sortable.Property'
      );
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'Module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryTemplatesTemplateDetailsLightModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryUsersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>;
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryUsersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>>;
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryUsersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>>;
  public queryUsers(
    requestParameters?: EmploymentConditionLibraryCustomerServiceQueryUsersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const searchString = requestParameters?.searchString;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const middlename = requestParameters?.middlename;
    const gid = requestParameters?.gid;
    const isApproverAuthorized = requestParameters?.isApproverAuthorized;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const module = requestParameters?.module;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (searchString !== undefined && searchString !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchString, 'SearchString');
    }
    if (firstname) {
      firstname.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Firstname');
      });
    }
    if (lastname) {
      lastname.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Lastname');
      });
    }
    if (middlename) {
      middlename.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Middlename');
      });
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (isApproverAuthorized !== undefined && isApproverAuthorized !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>isApproverAuthorized,
        'IsApproverAuthorized'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/users`;
    return this.httpClient.request<SharedPageModelOfEmploymentConditionLibraryUsersUserModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public rejectClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public rejectClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public rejectClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling rejectClauseVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling rejectClauseVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseVersionsRejectClauseVersionModel =
      requestParameters?.employmentConditionLibraryClauseVersionsRejectClauseVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseVersionsRejectClauseVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public rejectTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public rejectTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public rejectTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRejectTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling rejectTemplateVersions.');
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling rejectTemplateVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateVersionsRejectTemplateVersionModel =
      requestParameters?.employmentConditionLibraryTemplateVersionsRejectTemplateVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateVersionsRejectTemplateVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retireClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireClauseClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClausesClauseDetailsModel>;
  public retireClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireClauseClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public retireClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireClauseClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClausesClauseDetailsModel>>;
  public retireClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireClauseClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling retireClauseClauses.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClausesRetireClauseModel =
      requestParameters?.employmentConditionLibraryClausesRetireClauseModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/retire`;
    return this.httpClient.request<EmploymentConditionLibraryClausesClauseDetailsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClausesRetireClauseModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public retireTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplatesTemplateDetailsModel>;
  public retireTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public retireTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public retireTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceRetireTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling retireTemplates.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplatesRetireTemplateModel =
      requestParameters?.employmentConditionLibraryTemplatesRetireTemplateModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/retire`;
    return this.httpClient.request<EmploymentConditionLibraryTemplatesTemplateDetailsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplatesRetireTemplateModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendToApproverClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public sendToApproverClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public sendToApproverClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public sendToApproverClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling sendToApproverClauseVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling sendToApproverClauseVersions.');
    }
    const module = requestParameters?.module;
    const sharedEmploymentConditionLibrarySendToApproverModel =
      requestParameters?.sharedEmploymentConditionLibrarySendToApproverModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/send-to-approver`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedEmploymentConditionLibrarySendToApproverModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public sendToApproverTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public sendToApproverTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public sendToApproverTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public sendToApproverTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSendToApproverTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling sendToApproverTemplateVersions.'
      );
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling sendToApproverTemplateVersions.'
      );
    }
    const module = requestParameters?.module;
    const sharedEmploymentConditionLibrarySendToApproverModel =
      requestParameters?.sharedEmploymentConditionLibrarySendToApproverModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/send-to-approver`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedEmploymentConditionLibrarySendToApproverModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSimulateContentTemplateVersionSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<ConclusiveTransactionStatusOfTemplateSimulationMetadata>;
  public simulateContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSimulateContentTemplateVersionSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public simulateContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSimulateContentTemplateVersionSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<ConclusiveTransactionStatusOfTemplateSimulationMetadata>>;
  public simulateContentTemplateVersionSimulation(
    requestParameters?: EmploymentConditionLibraryCustomerServiceSimulateContentTemplateVersionSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error(
        'Required parameter versionId was null or undefined when calling simulateContentTemplateVersionSimulation.'
      );
    }
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling simulateContentTemplateVersionSimulation.'
      );
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateSimulationsSimulateTemplateContentModel =
      requestParameters?.employmentConditionLibraryTemplateSimulationsSimulateTemplateContentModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulation/simulate`;
    return this.httpClient.request<ConclusiveTransactionStatusOfTemplateSimulationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateSimulationsSimulateTemplateContentModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferClauseClausesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public transferClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferClauseClausesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public transferClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferClauseClausesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public transferClauseClauses(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferClauseClausesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling transferClauseClauses.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel =
      requestParameters?.employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferTemplateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferTemplateTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public transferTemplateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferTemplateTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public transferTemplateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferTemplateTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public transferTemplateTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceTransferTemplateTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling transferTemplateTemplates.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel =
      requestParameters?.employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTransferTransferEmploymentConditionsLibraryEntityModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateClauseVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryClauseVersionsClauseVersionModel>;
  public updateClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateClauseVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public updateClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateClauseVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryClauseVersionsClauseVersionModel>>;
  public updateClauseVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateClauseVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const clauseId = requestParameters?.clauseId;
    if (clauseId === null || clauseId === undefined) {
      throw new Error('Required parameter clauseId was null or undefined when calling updateClauseVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling updateClauseVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryClauseVersionsUpdateClauseVersionModel =
      requestParameters?.employmentConditionLibraryClauseVersionsUpdateClauseVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/clauses/${this.configuration.encodeParam({ name: 'clauseId', value: clauseId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryClauseVersionsClauseVersionModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryClauseVersionsUpdateClauseVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateContentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateContentTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>;
  public updateContentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateContentTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public updateContentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateContentTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public updateContentTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateContentTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling updateContentTemplateVersions.'
      );
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling updateContentTemplateVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateVersionsUpdateTemplateVersionContentModel =
      requestParameters?.employmentConditionLibraryTemplateVersionsUpdateTemplateVersionContentModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateVersionsUpdateTemplateVersionContentModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTemplateRuleSetTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateRuleSetTemplatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplatesTemplateDetailsModel>;
  public updateTemplateRuleSetTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateRuleSetTemplatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public updateTemplateRuleSetTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateRuleSetTemplatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplatesTemplateDetailsModel>>;
  public updateTemplateRuleSetTemplates(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateRuleSetTemplatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error(
        'Required parameter templateId was null or undefined when calling updateTemplateRuleSetTemplates.'
      );
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplatesUpdateTemplateRuleSetModel =
      requestParameters?.employmentConditionLibraryTemplatesUpdateTemplateRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/rule-set`;
    return this.httpClient.request<EmploymentConditionLibraryTemplatesTemplateDetailsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplatesUpdateTemplateRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateVersionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>;
  public updateTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateVersionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public updateTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateVersionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>>;
  public updateTemplateVersions(
    requestParameters?: EmploymentConditionLibraryCustomerServiceUpdateTemplateVersionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const templateId = requestParameters?.templateId;
    if (templateId === null || templateId === undefined) {
      throw new Error('Required parameter templateId was null or undefined when calling updateTemplateVersions.');
    }
    const versionId = requestParameters?.versionId;
    if (versionId === null || versionId === undefined) {
      throw new Error('Required parameter versionId was null or undefined when calling updateTemplateVersions.');
    }
    const module = requestParameters?.module;
    const employmentConditionLibraryTemplateVersionsUpdateTemplateVersionModel =
      requestParameters?.employmentConditionLibraryTemplateVersionsUpdateTemplateVersionModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (module !== undefined && module !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>module, 'module');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/templates/${this.configuration.encodeParam({ name: 'templateId', value: templateId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/versions/${this.configuration.encodeParam({ name: 'versionId', value: versionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmploymentConditionLibraryTemplateVersionsTemplateVersionModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryTemplateVersionsUpdateTemplateVersionModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceValidateDocumentGenerationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmploymentConditionLibraryDocumentGenerationMatchedTemplateModel>>;
  public validateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceValidateDocumentGenerationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmploymentConditionLibraryDocumentGenerationMatchedTemplateModel>>>;
  public validateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceValidateDocumentGenerationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmploymentConditionLibraryDocumentGenerationMatchedTemplateModel>>>;
  public validateDocumentGeneration(
    requestParameters?: EmploymentConditionLibraryCustomerServiceValidateDocumentGenerationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employmentConditionLibraryDocumentGenerationDocumentGenerationValidationRequestModel =
      requestParameters?.employmentConditionLibraryDocumentGenerationDocumentGenerationValidationRequestModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/condition-library/customer/v1/document-generation/validation`;
    return this.httpClient.request<Array<EmploymentConditionLibraryDocumentGenerationMatchedTemplateModel>>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employmentConditionLibraryDocumentGenerationDocumentGenerationValidationRequestModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
